'use strict';

// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import { ssoFiltreraDatatable } from 'v-components/ssoFiltreraDatatable';
import { ssoTogglaRaderIDatatable } from 'v-components/ssoTogglaRaderIDatatable';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(

// Övrigt:
import { ssoKontoplanDatatable } from 'datatables/ssoKontoplanDatatable';
import { ssoTooltips } from 'ssoTooltips';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';

//------------------------------------------------------------------------------------------------------------------------------

// Använd dessa Vue plugins:
Vue.use(ssoFiltreraDatatable);
Vue.use(ssoTogglaRaderIDatatable);

window.ssoKontoplan = window.ssoKontoplan || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.


//##############################################################################################################################

//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		tabellen: null,		// Initialt så. null betyder 'ännu inte satt'

		// Ytterligare data finns i ssoStateStore!
	},

	computed: {

		// ! Kan inte ersätta getter/setter nedan med mapState, för komponenten <toggla-rader-i-datatable> har denna som v-model = skriver till den = setter behövs. Skulle måhända gå att refactora och *ev* skulle det då även bli ett "renare" sätt.
		//...mapState('kontoplan', {
		//	oanvandaVisas: state => state.oanvandaVisas,
		//}),

		oanvandaVisas: {
			// getter
			get()
			{
				return this.$store.state.kontoplan.oanvandaVisas;
			},
			// setter
			set(value)
			{
				this.$store.commit('kontoplan/setOanvandaVisas', value)
			}
		},
	},

	watch: {
		oanvandaVisas(nyttVarde, tidigareVarde)
		{
			SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

			if (nyttVarde)
			{
				// Nya rader ska visas och har därmed lagts till i tabellen:
				// Tooltips måste bindas om (görs för hela sidan och jag tror *utan* att de gamla bindningarna avbinds! Osäker om det kan ge minnesläckor!):
				ssoTooltips.ominitiera();
			}
		},
	},

	methods: {

		onTogglingAvOanvanda(skaVisas)
		{
			// Vid klick/toggling på någon av de "generiska kryssrutorna" på sidan:
			// Detta behövs för att "kryssrutorna" äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			// Ytterligare åtgärder finns i 'watch:'!
		},
	},
	

	//== Lifecycle hooks  ================================================================================================================

	beforeCreate()
	{
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'kontoplan';
	},

	mounted()
	{
		// Note that mounted does not guarantee that all child components have also been mounted.

		console.time('#TIMING: initieraDataTable');	// Todo: TEMP!!!
		this.tabellen = ssoKontoplanDatatable.initiera(window.ssoKontoplan.dataSet);
		console.timeEnd('#TIMING: initieraDataTable');	// Todo: TEMP!!!

		SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');


		//this.$nextTick(function ()
		//{
		//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
		//	// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:
		//});
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
